import { datadogRum } from '@datadog/browser-rum';
import {getOAuthProviderVariablesInternal} from 'OAuthProviderVariables';

const environmentVariables = getOAuthProviderVariablesInternal();

datadogRum.init({
	applicationId: 'fd4f9b4c-e869-462e-8dcc-74dd38e587ad',
	clientToken: 'pub1bb3056e7674b33595949eb719139f60',
	site: 'us3.datadoghq.com',
	service: 'Standard-Insurance/ahtfg-portals/broker-web---broker-portal',
	version: process.env.VERSION || '0.0.0',
	env: environmentVariables.SPACE_NAME,
	sessionSampleRate: 100,
	sessionReplaySampleRate: 100,
	trackUserInteractions: true,
	trackResources: true,
	trackLongTasks: true,
	allowedTracingUrls: [/https:\/\/.*\.standard\.com/],
	defaultPrivacyLevel: 'mask-user-input'
});

datadogRum.setUser({ id: environmentVariables.SPACE_NAME });

datadogRum.addRumGlobalContext('space_name', environmentVariables.ENV);
datadogRum.addRumGlobalContext('org_name', 'broker-web');
datadogRum.addRumGlobalContext('CMDB', 'Standard-Insurance/ahtfg-portals/broker-web');
if (datadogRum.startSessionReplayRecording instanceof Function)
	datadogRum.startSessionReplayRecording();
